module.exports = __webpack_public_path__ + "img/img1.c5902843.png";